import '@app/globals.css';

import i18n from '@i18n/i18n';
import BackToTopButton from '@shared/backToTopButton/backToTopButton';
import Footer from '@shared/footer/footer';
import Navbar from '@shared/navbar/navbar';
import { AppProps } from 'next/app';
import Head from 'next/head';
import { I18nextProvider } from 'react-i18next';

function MyApp({ Component, pageProps }: AppProps) {
    return (
        <I18nextProvider i18n={i18n}>
            <>
                <Head>
                    <title>Josephine Noa Bayle</title>
                </Head>
                <Navbar />
                <Component {...pageProps} />
                <BackToTopButton />
                <Footer />
            </>
        </I18nextProvider>
    );
}

export default MyApp;
